module.exports = __webpack_public_path__ + "static/media/bg_smurfs.dc95b90c.mp3";